import { getSignInAuth, getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function signOut() {
    try {
        await getSignInAuth().signOut();
        await getSignUpAuth().signOut();
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
